var intersectionD = require('./../distances/intersection');

module.exports = function intersection(a, b) {
    return 1 - intersectionD(a,b);
};



// WEBPACK FOOTER //
// ./node_modules/ml-distance/src/similarities/intersection.js